import React from 'react';
import styles from './styles.module.scss';
import {observer} from 'mobx-react-lite';
import Chart from '../componenets/Chart/Chart';
import {Flex} from '@priority-software/priority-style-react';

const ChartDisplayPage = observer(() => {
    return (
        <Flex justifyContent="center" alignItems="center" componentClasses={styles.container}>
            <Chart />
        </Flex>
    );
});

export default ChartDisplayPage;
